<div class="translation-form">
  <app-dynamic-form
    (onFormLanguageChanged)="onLanguageChanged($event)"
    [formProperties]="formProperties"
    [formGroup]="formGroup"
  >
  </app-dynamic-form>
  @if (postTranslationLoading$ | async) {
    <app-loading></app-loading>
  }
  <div class="toolbar">
    @if (!hasTranslationLanguage) {
      <sui-button
        variant="primary"
        [leadingIcon]="['fas', 'plus']"
        (click)="setTranslation()"
      >
        {{ "btn.create" | translate }}
      </sui-button>
    }

    @if (hasTranslationLanguage) {
      <sui-button
        variant="primary"
        [leadingIcon]="['fas', 'edit']"
        (click)="setTranslation()"
      >
        {{ "btn.update" | translate }}
      </sui-button>
    }

    <sui-button
      variant="secondary"
      [leadingIcon]="['fas', 'language']"
      (click)="translateContent()"
    >
      {{ "post-translation.button.translate" | translate }}
    </sui-button>

    <sui-button
      variant="secondary"
      [leadingIcon]="['fas', 'copy']"
      (click)="copyFromOriginal()"
    >
      {{ "post-translation.button.copy-from-original" | translate }}
    </sui-button>
  </div>
</div>
